// extracted by mini-css-extract-plugin
export default {"left":"Button-module__[local]___V9Th+","center":"Button-module__[local]___spdN9","right":"Button-module__[local]___ajeyr"};